<script>
import ChallengeForm from './ChallengeForm'

export default {
  name: 'PageChallengeAdd',

  components: {
    ChallengeForm
  }
}
</script>

<template>
  <section class="hero is-primary">
    <div class="container">
      <h1 class="title is-2">Ajouter un challenge</h1>

      <challenge-form/>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 640px;
}

.hero {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageChallengeAdd.vue